import angular from 'angular';

import cmsGridDirective from '../../Grid/GridDirective';
import GridParamsConverter from '../../Grid/GridParamsConverter';
import PageResource from '../PageResource'
import gettext from 'angular-gettext';
import appConfig from '../../ConfigModule/ConfigModule'

let pageFormDataGridModule = angular.module('cms.page.form.data.grid', [cmsGridDirective, PageResource, gettext, appConfig, GridParamsConverter])
    .component('pageFormDataGrid', {
        template: require('./page-form-data-grid.html'),
        bindings: {
            initialParams: '<?',
            onParamsChange: '&?',
            onPageChange: '&?',
            columns: '='
        },
        controller: function (PageResource, gettextCatalog, toastr, CONFIG, GridParamsConverter, $state) {
            /** @ngInject */

            this.$onInit = () => {
                this.initialFilterModel = {};
                let dataInitialized = false;


                const defaultParams = {
                    order_by: undefined,
                    order_direction: undefined
                };


                if (!this.initialParams) {
                    this.initialParams = angular.copy(defaultParams);
                }

                if (this.initialParams.order_by) {
                    this.initialSortModel = [
                        {colId: this.initialParams.order_by, sort: this.initialParams.order_direction || 'asc'}
                    ];
                }

                if (this.initialParams.page) {
                    this.initialPage = this.initialParams.page;
                }

                this.form = undefined;

                let getColumnDefs = () => {

                    let columns = [{
                        headerName: gettextCatalog.getString('Date'),
                        field: "createdAt",
                        filter: 'date',
                        filterParams: {filterOptions: ['inRange']}
                    }];
                    if(this.columns) {
                        this.columns.forEach(input => {
                            let key = input.config.key;
                            if (['formText', 'formTextarea', 'formEmail', 'formNumber'].indexOf(input.type) > -1) {
                                columns.push({
                                    headerName: input.config.label || input.config.placeholder,
                                    field: 'data.' + key,
                                })
                            }
                            if (['formDate', 'formDateTime'].indexOf(input.type) > -1) {
                                columns.push({
                                    headerName: input.config.label || input.config.placeholder,
                                    field: 'data.' + key,
                                    filter: 'date',
                                    filterParams: {filterOptions: ['inRange']},
                                    cellRenderer: function (params) {
                                        if (params.data.data[key]) {
                                            return (input.type === 'formDate') ?
                                                params.data.data[key].date.substr(0, 10) :
                                                params.data.data[key].date.substr(0, 16);
                                        }
                                        return '';
                                    }
                                })
                            }
                        });
                    }
                    columns.push({
                        headerName: gettextCatalog.getString("Actions"),
                        suppressFilter: true,
                        cellRenderer: function (params) {
                            let buttons = angular.element('<div></div>');
                            let button = angular.element(`<button class="btn btn-xs btn-primary">
                                        <em class="ion-eye"></em>
                                        ${gettextCatalog.getString('Show details')}
                                    </button>`);

                            button.on('click', function () {
                                $state.go('pageFormDataDetails', {
                                    id: params.data.id,
                                    returnState: {
                                        name: 'pageFormData',
                                        params: angular.copy($state.params)
                                    }
                                })
                            });
                            buttons.append(button[0]);
                            return buttons[0];
                        }
                    });
                    return columns;
                };

                this.options = {
                    _columnDefsCallback: getColumnDefs,
                    enableColResize: false
                };

                let responseData = [];
                this.datasource = {
                    getRows: params => {
                        let queryParams = GridParamsConverter.getCmsApiParams(params);
                        queryParams['pageId'] = $state.params.id;
                        let stateParams = Object.assign({}, defaultParams, queryParams);

                        if (this.onParamsChange)
                            this.onParamsChange({params: angular.copy(stateParams)});

                        delete stateParams.page;
                        $state.go('.', stateParams, {
                            location: 'replace'
                        });


                        PageResource.findFormData(queryParams, response => {
                                responseData = response.data;
                                responseData.map(data => {
                                    data.createdAt = (new Date(data.createdAt)).toLocaleString();
                                });
                                let lastRow = response.total_count;
                                params.successCallback(responseData, lastRow);

                                if (!dataInitialized && this.initialPage && this.initialPage !== this.options.api.paginationGetCurrentPage() + 1) {
                                    dataInitialized = true;
                                    this.options.api.paginationGoToPage(parseInt(this.initialPage) - 1);
                                }
                                this.totalCount = response.total_count;
                            }, errResponse => {
                            }
                        );
                    }
                };

                this._onPageChange = page => {
                    if (!dataInitialized)
                        return;
                    if (this.onPageChange)
                        this.onPageChange({$page: page});
                };

            };
        }
    });

export default pageFormDataGridModule.name;




// WEBPACK FOOTER //
// ./src/cmsCore/PagesModules/PageFormDataGrid/PageFormDataGrid.js